import React, { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import { xtreamApi } from '../../services/xtreamApi';

const FavoriteButton = ({ contentId, contentType, name, poster, rating, className = '', size = 'sm' }) => {
  const [isFav, setIsFav] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!contentId || !xtreamApi.isAuthenticated()) return;
    xtreamApi.checkFavorite(String(contentId), contentType).then(setIsFav).catch(() => {});
  }, [contentId, contentType]);

  const toggle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (loading) return;
    setLoading(true);
    try {
      if (isFav) {
        await xtreamApi.removeFavorite(String(contentId), contentType);
        setIsFav(false);
      } else {
        await xtreamApi.addFavorite(String(contentId), contentType, name, poster, rating);
        setIsFav(true);
      }
    } catch (err) {
      console.error('Favorite toggle error:', err);
    }
    setLoading(false);
  };

  const sizeClasses = size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';

  return (
    <button
      data-testid={`favorite-btn-${contentType}-${contentId}`}
      onClick={toggle}
      disabled={loading}
      className={`transition-all ${loading ? 'opacity-50' : ''} ${className}`}
      title={isFav ? 'Remove from favorites' : 'Add to favorites'}
    >
      <Heart className={`${sizeClasses} transition-colors ${isFav ? 'text-red-500 fill-red-500' : 'text-white/70 hover:text-red-400'}`} />
    </button>
  );
};

export default FavoriteButton;
